// Lib Imports
import React from "react";
const withInlineEdit = Table => {
  const Component = props => {
    return /*#__PURE__*/React.createElement(Table, null);
  };
  return Component;
};
export default withInlineEdit;